
import Compressor from 'compressorjs';

const compressorConfig = {
    quality: 0.4,
    maxWidth: 800,
    maxHeight: 800,
    convertSize: 0,
    mimeType: "image/webp",
}

const compressorFile = async (file, config = compressorConfig) => {
    return new Promise((resolve, reject) => {
        new Compressor(file, {
            ...config,
            success(result) {
                resolve(result);
            },
            error(err) {
                console.error(err.message);
                reject(err);
            },
        });
    })
}

export default { compressorFile }